import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
export function usePagination(initialPagination, items) {
  var _React$useState = React.useState(initialPagination),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      pagination = _React$useState2[0],
      setPagination = _React$useState2[1];

  var maxPage = Math.ceil(items.length / pagination.size);
  return _objectSpread(_objectSpread({}, pagination), {}, {
    pages: Array.from({
      length: maxPage
    }, function (_, i) {
      return i + 1;
    }),
    paginate: paginate,
    setSize: setSize,
    set: set
  });

  function set(page, size) {
    setPagination({
      page: page || pagination.page,
      size: size || pagination.size
    });
  }

  function paginate(page) {
    if (page === undefined || page < 1 || page > maxPage) {
      return pagination;
    }

    var nextPagination = _objectSpread(_objectSpread({}, pagination), {}, {
      page: page
    });

    setPagination(nextPagination);
    return nextPagination;
  }

  function setSize(size) {
    if (size === undefined || size <= 0) {
      return pagination;
    }

    var nextPagination = _objectSpread(_objectSpread({}, pagination), {}, {
      size: size
    });

    setPagination(nextPagination);
    return nextPagination;
  }
}